import React, { useContext } from 'react';
import { Message, Icon } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import { FORM_ERROR_KEY, FORM_SUCCESS_KEY } from '../../DynamicForm.constants';
import { DynamicFormContext } from '../../context/DynamicFormContext';
function DynamicFormAlert() {
  var _useContext = useContext(DynamicFormContext),
    notification = _useContext.notification;
  var message = notification.message,
    type = notification.type;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !_isEmpty(message) && /*#__PURE__*/React.createElement(Message, {
    success: type === FORM_SUCCESS_KEY,
    negative: type === FORM_ERROR_KEY
  }, /*#__PURE__*/React.createElement(Message.Content, null, type === FORM_SUCCESS_KEY && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
    name: "check circle outline"
  })), type === FORM_ERROR_KEY && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
    name: "warning circle"
  })), message)));
}
export default DynamicFormAlert;